import { Injectable } from '@angular/core';
import { Season } from '@app/models';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';

const API = environment.API;
@Injectable({
  providedIn: 'root'
})
export class SeasonService {
  constructor(private http: HttpClient) {}

  get() {
    return this.http.get<Season[]>(`${API}seasons`);
  }
}
